import React from 'react';
import { Form } from 'src/components/Antd';
import Co from 'src/constrains/AdvancedFilters/Collapse';
import { PromotionApplied } from 'src/constrains/AdvancedFilters/Components';
import { EInclude } from 'src/constrains/AdvancedFilters/Components/CommonRadioMulSelect';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Item = Form.Item;

const _PromotionApplied = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    rootName,
    form,
    noStyle,
    radioName,
    selectName,
    selectOptions,
    defaultState,
    ...rest
  } = props;

  const handleOnReset = () => {
    form.setFieldsValue(defaultState);
  };
  return (
    <Item
      noStyle
      shouldUpdate={(p, c) => {
        const touched = form.isFieldTouched(rootName);
        return touched; //|| cv !== pv;
      }}>
      {(f) => {
        const { getFieldValue } = f;
        const type = getFieldValue(radioName);
        const handleOnClose = () => {
          form
            .validateFields([radioName, selectName])
            .then(() => {
              //console.log('没错');
            })
            .catch((r) => {
              handleOnReset();
            });
        };
        const selectedUuid = getFieldValue(selectName) || [];
        const selectPromotion = selectedUuid.map((i) => {
          const item = selectOptions.find((option) => {
            return option.value === i;
          });
          if (item) {
            return item.label;
          }
          return '';
        });
        const hasData = !!type;
        const textGenerator = () => {
          const prefix = {
            [EInclude.any]: getI18n(
              'customerList.advancedFilter.appliedanyofthepromotions',
            ),
            [EInclude.all]: getI18n(
              'customerList.advancedFilter.appliedallofthepromotions',
            ),
            [EInclude.EXCLUDE_ALL_SELECTED]: getI18n(
              'customerList.advancedFilter.appliedneitherofthepromotions',
            ),
            [EInclude.EXCLUDE_ANY_SELECTED]: getI18n(
              'customerList.advancedFilter.appliedeitherofthepromotions',
            ),
          };
          if (hasData) {
            return `${prefix[type] || ''} (${selectPromotion.join(',')})`;
          }
          return '';
        };
        return (
          <Co
            header={
              <div>
                {getI18n('customerList.promotionApplied.discountapplied')}
              </div>
            }
            displayText={textGenerator()}
            hasData={hasData}
            onClose={handleOnClose}
            onClear={handleOnReset}>
            <PromotionApplied
              noStyle={noStyle}
              selectName={selectName}
              treeOptions={selectOptions}
              radioName={radioName}
              {...rest}
            />
          </Co>
        );
      }}
    </Item>
  );
};
export default _PromotionApplied;
